import React from 'react';
import useThemeColors from '../../hooks/useThemeColors';

const ChartCard = ({ 
  title, 
  description, 
  children, 
  className = "",
  icon: Icon
}) => {
  const { isDark } = useThemeColors();
  
  return (
    <div className={`--theme-colors rounded-lg shadow-md ${className}`}>
      <div className={`p-4 sm:p-6 border-b ${isDark ? 'border-gray-700' : 'border-gray-100'}`}>
        <div className="flex items-center gap-2 mb-2">
          {Icon && <Icon className={`w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 ${
            isDark ? 'text-gray-400' : 'text-gray-600'
          }`} />}
          <h3 className={`text-base sm:text-lg font-semibold --theme-colors`}>
            {title}
          </h3>
        </div>
        {description && (
          <p className={`text-xs sm:text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
            {description}
          </p>
        )}
      </div>
      <div className="p-4 sm:p-6">
        {children}
      </div>
    </div>
  );
};

export default ChartCard; 